module.exports = __webpack_public_path__ + "static/media/china-and-hong-kong.244bb527.svg";